import { get as lodashGet } from 'lodash';

export default function createGet(data) {
  return (...args) =>
    typeof args[0] === 'object' ? lodashGet(...args) : lodashGet(data, ...args);
}
